<template>
  <nuxt-link
    :id="mobile ? 'mobile-cellar-trigger' : 'cellar-trigger'"
    class="btn-nav-cellar"
    to="/cellar/wines/"
  >
    <template v-if="mobile">
      <img :src="mobileImageSrc" />
      <span>My Cellar</span>
      <AlertBadge />
    </template>
    <template v-else>
      <AlertBadge />
      <span>My Cellar</span>
    </template>
  </nuxt-link>
</template>
<script setup>
import { getProductNotifications } from '~/services/notificationServices'

const { $auth, $axios, $store } = useNuxtApp()

const notifications = computed(() => $store?.getters?.notifications || [])

defineProps({
  mobile: {
    type: Boolean,
    default: false,
  },
  mobileImageSrc: {
    type: String,
    default: '',
  },
})

onMounted(async () => {
  try {
    if (notifications.value.length === 0 && $auth?.loggedIn) {
      const fetched = await getProductNotifications($axios)
      await $store.dispatch('setNotifications', fetched)
    }
  } catch (e) {
    Sentry.captureException(e)
  }
})
</script>
